var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-layout-history-template',{attrs:{"isBread":true,"breadHeading":'検索履歴'},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.searchHistoryReady)?_c('search-history-contents'):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }